
import { Purchase } from "@/models/base";
import { PurchaseLedger } from "@/models/base/purchase-ledger";
import Vue from "vue";
import { IDataTableColumn } from "winfakt-vue-components";
import { printHumanFloat } from "@/utils/pretty-print";
import {LedgerAccountService} from "@/services";
import {LedgerAccount} from "@/models/ledger-account";
export default Vue.extend({
	data(){
		return {
			selectedItems: [] as PurchaseLedger[],
			ledgers: [] as LedgerAccount[]
		};
	},
	props: {
		purchase: {
			type: Object as ()=>Purchase,
			required: true
		},
	},
	computed: {
		cols():IDataTableColumn[]{
			return [
				{
					name: this.$ct("code").toString(),
					property: "LedgerCode",
					width: "80px"
				},
				{
					name: this.$ct("description").toString(),
					property: "LedgerAccount.Description",
					width: "200px",
				},
				{
					name: this.$ct("netto").toString(),
					property: "Amount",
					width: "80px",
					right: true,
					print(value:number):string{
						return printHumanFloat(value);
					}
				},
				{
					name: this.$ct("vat-percentage-short").toString(),
					property: "VatPercent",
					width: "60px"
				},
				{
					name: this.$ct("comment").toString(),
					property: "Comment",
					width: "280px"
				}
			] as IDataTableColumn[];
		},
	},
	watch: {
		selectedItems: {
			deep: true,
			handler(){
				if (this.selectedItems.length == 0) return;
				this.selectedItems.splice(0, this.selectedItems.length);
			}
		},
	},
	async mounted(){
		this.ledgers = await LedgerAccountService.fetchLedgerAccounts();
		this.purchase.Ledgers.map((l)=>{
			let f = this.ledgers.filter((x)=>x.Code==l.LedgerCode);
			if(!l.LedgerAccount){
				l.LedgerAccount = new LedgerAccount();
			}
			l.LedgerAccount.Description = f[0].Description;
			return l;
		});
	},
	i18nEx: {
		componentPrefix: "components.purchases"
	}
});
